<template>
  <default-layout>
    <section slot="content">

      <!-- HERO -->

      <v-container class="mt-6">

        <v-carousel
          hide-delimiters
          cycle
          show-arrows-on-hover
          height="auto"
        >

          <v-carousel-item
            v-for="(hero, i) in items"
            :key="hero.id"
          >

            <div class="">
              <v-img
                :src="hero.image"
                height="100%"
                @click="redirect(hero.group)"
              ></v-img>

              <!-- <div class="hero-overlay"></div> -->

              <!-- <div class="hero-content">

                <div class="hero-badge">
                  {{ hero.badge }}
                </div>

                <div class="hero-title">
                  {{ hero.title }}
                </div>

                <div class="hero-sub">
                  {{ hero.subtitle }}
                </div>

                <v-btn
                  x-large
                  color="#dc2e3d"
                  dark
                  class="hero-btn"
                >
                  Comprar ahora
                </v-btn>

              </div> -->

            </div>

          </v-carousel-item>

        </v-carousel>

      </v-container>

      <!-- TRUST -->

      <v-container>

        <div class="trust-bar pa-5 pa-md-7">

          <v-row align="center">

            <v-col
              cols="6"
              md="3"
              v-for="(trust,i) in trusts"
              :key="i"
            >

              <div class="d-flex align-center">

                <v-icon
                  size="42"
                  color="primary"
                >
                  {{ trust.icon }}
                </v-icon>

                <div class="ml-4">

                  <div
                    class="font-weight-bold"
                    style="font-size:16px;"
                  >
                    {{ trust.title }}
                  </div>

                  <div
                    style="
                      color:#64748b;
                      font-size:13px;
                    "
                  >
                    {{ trust.text }}
                  </div>

                </div>

              </div>

            </v-col>

          </v-row>

        </div>

      </v-container>

      <!-- CATEGORIES v2 -->
      <v-container class="mt-14">
        <div class="section-title">
          Explora Categorías
        </div>

        <div class="section-subtitle">
          Encuentra rápidamente lo que más buscas
        </div>

        <!-- MOBILE -->

        <div
          v-if="isMobile"
          class="categories-scroll"
        >

          <div
            v-for="cat in categories"
            :key="cat.id"
            class="category-card"
          >

            <img
              :src="`/static/categories/${cat.icon}`"
              @click="redirect(cat.name)"
              class="category-img"
            >

            <div class="category-name">
              {{ cat.name }}
            </div>

          </div>

        </div>

        <!-- DESKTOP -->

        <div
          v-else
          class="categories-grid"
        >

          <div
            v-for="cat in categories.slice(0,7)"
            :key="cat.id"
            class="category-card"
          >

            <img
              :src="`/static/categories/${cat.icon}`"
              @click="redirect(cat.name)"
              class="category-img"
            >

            <div class="category-name">
              {{ cat.name }}
            </div>

          </div>

          <div
            class="category-card category-all"
           @click="redirect('')"
          >

            <v-icon size="40">
              mdi-arrow-right
            </v-icon>

            <div class="category-name">
              Ver todas
            </div>

          </div>

        </div>
      </v-container>

      <!-- FLASH -->

      <v-container 
        class="mt-14"
        v-for="(fla, i) in flash"
        :key="fla.id"
        v-if="!fla.expired"
      >

        <div class="flash-sale pa-8 pa-md-12">

          <v-row align="center">

            <v-col
              cols="12"
              md="7"
            >

              <div class="flash-title">
                {{ fla.title }}
              </div>

              <div class="mt-3 text-h6 font-weight-regular">
                {{ fla.description }}
              </div>

              <div class="flash-timer">
                <div class="time-box">
                  <div class="time-number">{{ fla.countdown.hours }}</div>
                  <div class="time-label">Horas</div>
                </div>

                <div class="time-box">
                  <div class="time-number">{{ fla.countdown.minutes }}</div>
                  <div class="time-label">Min</div>
                </div>

                <div class="time-box">
                  <div class="time-number">{{ fla.countdown.seconds }}</div>
                  <div class="time-label">Seg</div>
                </div>
              </div>

              <v-btn
                :color="fla.color || 'primary'"
                @click="redirect(fla.group)"
                x-large
                class="mt-7"
                :style="{
                  color: fla.color === 'white' ? '#e91e63' : 'white',
                  borderRadius: '18px',
                  fontWeight: '800'
                }"
              >
                {{ fla.button_text || 'Ver' }}
              </v-btn>

            </v-col>

            <v-col
              cols="12"
              md="5"
              class="text-center"
            >

              <img
                :src="fla.image"
                style="
                  width:100%;
                  max-width:340px;
                  border-radius:26px;
                  box-shadow:0 15px 35px rgba(0,0,0,.2);
                "
              >

            </v-col>

          </v-row>

        </div>

      </v-container>

      <!-- MINI SLIDER UX -->

      <v-container class="mt-16">

        <v-row
          align="center"
          class="mb-4"
        >

          <v-col cols="6">

            <div class="section-title">
              Tendencias
            </div>

          </v-col>

          <v-col
            cols="6"
            class="text-right"
          >

            <v-btn
              text
              color="primary"
              class="font-weight-bold"
            >
              Explorar
            </v-btn>

          </v-col>

        </v-row>

        <v-carousel
          hide-delimiter-background
          cycle
          show-arrows-on-hover
          height="auto"
        >

          <v-carousel-item
            v-for="(tre, i) in trending"
            :key="i"
          >

            <div class="mini-slide-card pa-6 pa-md-10">

              <v-row align="center">

                <v-col
                  cols="12"
                  md="6"
                >

                  <div
                    :class="!tre.color ? 'primary--text' : ''"
                    :style="tre.color ? { color: tre.color } : {}"
                    style="font-weight:800; margin-bottom:14px;"
                  >
                    {{ tre.badge ? tre.badge.toUpperCase() : '' }}
                  </div>

                  <div
                    style="
                      font-size:52px;
                      font-weight:900;
                      line-height:1;
                      color:#0f172a;
                    "
                  >
                    {{ tre.title }}
                  </div>

                  <div
                    class="mt-5"
                    style="
                      color:#64748b;
                      line-height:1.9;
                    "
                  >
                    {{ tre.description }}
                  </div>

                  <v-btn
                    :color="tre.color || 'primary'"
                    @click="redirect(tre.group)"
                    dark
                    x-large
                    class="mt-7"
                    style="
                      border-radius:18px;
                      font-weight:800;
                    "
                  >
                    {{ tre.button_text || 'Ver' }}
                  </v-btn>

                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                >

                  <img
                    :src="tre.image"
                    style="
                      width:100%;
                      max-width:450px;
                      border-radius:28px;
                      box-shadow:
                      0 18px 45px rgba(0,0,0,.12);
                    "
                  >

                </v-col>

              </v-row>

            </div>

          </v-carousel-item>

        </v-carousel>

      </v-container>

      <!-- MINI SLIDER COLLECTION -->
      
      <v-container
        fluid
        class="collection-section py-8"
        v-for="(groupRow, i) in footerList"
        :key="i"
      >

        <v-row justify="center">

          <v-col
            cols="12"
            lg="10"
            md="11"
          >

            <div class="section-header">

              <div>

                <div class="section-badge">
                  COLECCIÓN
                </div>

                <div class="section-title">
                  {{ groupRow.title }}
                </div>

                <div class="section-subtitle">
                  Descubre nuestras novedades
                </div>

              </div>

            </div>

          </v-col>

        </v-row>

        <!-- MOBILE -->

        <v-row
          v-if="isMobile"
          justify="center"
          class="mt-4"
        >

          <v-col
            cols="12"
          >

            <v-carousel
              cycle
              interval="5000"
              hide-delimiters
              hide-delimiter-background
              height="auto"
            >

              <v-carousel-item
                v-for="body in groupRow.list"
                :key="body.id"
              >

                <div
                  class="mobile-banner-wrapper"
                  @click="redirect(body.group)"
                >

                  <v-img
                    :src="body.image"
                    contain
                    eager
                    class="mobile-banner"
                  />

                </div>

              </v-carousel-item>

            </v-carousel>

          </v-col>

        </v-row>

        <!-- DESKTOP -->

        <v-row
          v-else
          justify="center"
          class="mt-4"
        >

          <v-col
            cols="12"
            lg="10"
            md="11"
          >

            <div class="desktop-slider">

              <v-slide-group
                show-arrows="always"
                center-active
              >

                <v-slide-item
                  v-for="body in groupRow.list"
                  :key="body.id"
                >

                  <div
                    class="desktop-banner-wrapper"
                    @click="redirect(body.group)"
                  >

                    <v-img
                      :src="body.image"
                      contain
                      eager
                      class="desktop-banner"
                    />

                  </div>

                </v-slide-item>

              </v-slide-group>

            </div>

          </v-col>

        </v-row>

      </v-container>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'

  export default {
    name: 'HomePage',
    components: {
      DefaultLayout
    },
    metaInfo() {
      return {
        title: 'Dino-Toys.com ¡Las mejores ofertas en miles de productos!',
        meta: [
          { name: 'description', content: 'Lo último en tendencias en Juguetes y Ropas, con estilo y al mejor precio.' },
          { property: 'og:title', content: 'Dino-Toys.com | Lo mejor en Juguete, Moda y más' },
          { property: 'og:site_name', content: 'Dino Toys' },
          { property: 'og:description', content: 'Compra en Dino Toys lo que necesitas para el pequeño del hogar, divertirte en casa con lo último en tendencia en Juguetes, Ropa, con estilo y al mejor precio..' },
          { property: 'og:url', content: 'https://www.dino-toys.com/' },
          { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img%2Flogos%2Flogo_meta.jpg?alt=media&token=4a5db43f-4ff5-4d47-99e4-bea4fab9432b' }
        ]
      }
    },
    data () {
      return {
        headerData: [],
        flash: [],
        flashInterval: null,
        trending: [],
        footerList: [],
        trusts:[
          {
            icon:"mdi-shield-check",
            title:"Compra segura",
            text:"Pagos protegidos"
          },

          {
            icon:"mdi-truck-fast",
            title:"Delivery rápido",
            text:"Lima y provincia"
          },

          {
            icon:"mdi-whatsapp",
            title:"Atención inmediata",
            text:"Respuesta rápida"
          },

          {
            icon:"mdi-sale",
            title:"Ofertas diarias",
            text:"Promociones reales"
          }
        ],

        categories:[],
      }
    },
    computed: {
      items() {
        return this.headerData.filter(item =>
          this.isMobile
            ? Number(item.type) === 100
            : Number(item.type) === 1
        );
      },

      groupedFooterList() {

        return (list) => {

          const result = [];

          for (let i = 0; i < list.length; i += 3) {

            result.push(
              list.slice(i, i + 3)
            );

          }

          return result;

        };

      },

      isMobile() {
        return this.$vuetify.breakpoint.smAndDown;
      }
    },
    methods: {
      loadHome() {
        axios.get(process.env.DINO.PATH.GET_HOME)
          .then(response => {

            this.headerData = response.data.header;

            const flash = response.data.body
            .filter(item =>
              item.section && item.section.name == 'Ofertas'
            )
            .map(item => ({
              ...item,
              countdown: {
                hours: '00',
                minutes: '00',
                seconds: '00'
              },
              expired: false
            }))

            const trending = response.data.body.filter(item =>
              item.section && item.section.name == 'Tendencias'
            )

            this.flash = flash;
            this.trending = trending;
            this.footerList = response.data.footer;

            this.startFlashCountdown();

            localStorage.setItem('header', JSON.stringify(this.headerData));
            localStorage.setItem('flash', JSON.stringify(flash));
            localStorage.setItem('trending', JSON.stringify(trending));
            localStorage.setItem('footer', JSON.stringify(response.data.footer));
          })
          .catch(err => {
            this.headerData = JSON.parse(localStorage.getItem('header'));
            this.flash = JSON.parse(localStorage.getItem('flash'));
            this.trending = JSON.parse(localStorage.getItem('trending'));
            this.footerList = JSON.parse(localStorage.getItem('footer'));
          });
      },
      startFlashCountdown() {
        this.flashInterval = setInterval(() => {
          this.flash.forEach(item => {

            const end = new Date(item.offer_end_date.replace(' ', 'T')).getTime()
            const now = Date.now()
            const diff = end - now

            if (diff <= 0) {
              item.expired = true
              item.countdown = {
                hours: '00',
                minutes: '00',
                seconds: '00'
              }
              return
            }

            const hours = Math.floor(diff / (1000 * 60 * 60))
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((diff % (1000 * 60)) / 1000)

            item.countdown = {
              hours: String(hours).padStart(2, '0'),
              minutes: String(minutes).padStart(2, '0'),
              seconds: String(seconds).padStart(2, '0')
            }

          })

        }, 1000)
      },
      getCategories() {
        this.categories = JSON.parse(localStorage.getItem('moduls'));
        if (!this.categories || this.categories.length === 0) {
          axios.get(process.env.DINO.PATH.GET_MODULS)
          .then(response => {
            this.categories = response.data;
            localStorage.setItem('moduls', JSON.stringify(response.data));
          })
          .catch(err => {
            this.categories = JSON.parse(localStorage.getItem('moduls'));
          });
        }
      },
      goWhatsapp () {
        const urlWhatsapp = `*DINO!* - Quiero información de sus productos.%0D%0A%0D%0A_%C2%A1+Gracias+%21_`;
        return `https://api.whatsapp.com/send?phone=51987839662&text=${urlWhatsapp}`;
      },

      redirect: function(group) {
        this.$router.push({ name:'Products', query: { q: group, orderBy: 'OrderByReleaseDateDESC', page: 1 } }).catch(err => {});
      }
    },
    beforeDestroy() {
      clearInterval(this.flashInterval)
    },
    mounted() {
      this.loadHome();
      this.getCategories();
    }
  }
</script>
<style scoped>
  /* HERO */

  .hero{
    position:relative;
    overflow:hidden;
    border-radius:38px;
    min-height:620px;
    box-shadow: 0 25px 60px rgba(0,0,0,.15);
  }

  /* .hero-overlay{
    position:absolute;
    inset:0;
    background:
    linear-gradient(
    90deg,
    rgba(0,0,0,.72),
    rgba(0,0,0,.25),
    rgba(0,0,0,.05)
    );
    z-index:2;
  } */

  .hero-content{
    position:absolute;
    z-index:3;
    top:50%;
    left:70px;
    transform:translateY(-50%);
    max-width:560px;
    color:white;
  }

  .hero-badge{
    display:inline-flex;
    align-items:center;
    background:rgba(255,255,255,.18);
    backdrop-filter:blur(12px);
    padding:10px 18px;
    border-radius:999px;
    font-weight:700;
    margin-bottom:24px;
  }

  .hero-title{
    font-size:72px;
    line-height:1;
    font-weight:900;
    letter-spacing:-3px;
    margin-bottom:24px;
  }

  .hero-sub{
    font-size:19px;
    opacity:.92;
    line-height:1.8;
    margin-bottom:32px;
  }

  .hero-btn{
    height:62px !important;
    padding:0 34px !important;
    border-radius:20px !important;
    font-weight:800 !important;
    font-size:16px !important;
    box-shadow:
    0 14px 30px rgba(255,77,109,.45);
  }

  /* NUEVO HERO MOBIL */
  @media(max-width:960px){
    .hero{
      min-height:350px;
      border-radius:24px;
    }
  }

  @media(max-width:960px){
    .hero-content{
      left:24px;
      right:24px;
      max-width:none;
      text-align: center;
    }

    .hero-title{
      font-size:38px;
      letter-spacing:-1px;
    }

    .hero-sub{
      font-size:16px;
      line-height:1.6;
    }
  }

  /* TRUST BAR */

  .trust-bar{
    background:white;
    border-radius:24px;
    margin-top:-45px;
    position:relative;
    z-index:5;
    box-shadow:
    0 18px 45px rgba(0,0,0,.08);
    border:1px solid #edf2f7;
  }

  /* CATEGORIES V2 */
  .categories-grid{
    display:grid;
    grid-template-columns:
      repeat(4,1fr);
    gap:20px;
    margin-top:30px;
  }

  .category-card{
    background:white;
    border-radius:22px;
    padding:18px;
    text-align:center;
    cursor:pointer;
    transition:.25s;
    border:1px solid #edf2f7;
  }

  .category-card:hover{
    transform:
      translateY(-6px);
    box-shadow:
      0 12px 30px rgba(0,0,0,.08);
  }

  .category-img{
    width:90px;
    height:90px;
    object-fit:cover;
    /* border-radius:18px; */
  }

  .category-name{
    margin-top:12px;
    font-weight:700;
  }

  .category-all{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
  }

  .categories-scroll{
    display:flex;
    gap:20px;
    overflow-x:auto;
    padding-bottom:10px;
    scrollbar-width:none;
  }

  .categories-scroll::-webkit-scrollbar{
    display:none;
  }

  /* FLASH */

  .flash-sale{
    background:
    linear-gradient(
      135deg,
      #dc2e3d,
      #e6667d
    );

    border-radius:30px;
    overflow:hidden;
    position:relative;
    color:white;
    box-shadow:
      0 18px 40px rgba(255,77,109,.28);
  }

  .flash-title{
    font-size:40px;
    font-weight:800;
  }

  .flash-timer{
    display:flex;
    gap:12px;
    margin-top:20px;
  }

  .time-box{
    background:rgba(255,255,255,.18);
    backdrop-filter:blur(10px);
    border-radius:18px;
    padding:14px;
    min-width:72px;
    text-align:center;
  }

  .time-number{
    font-size:28px;
    font-weight:800;
  }

  .time-label{
    font-size:12px;
    opacity:.9;
  }

  /* MINI SLIDER */

  .mini-slide-card{
    background:white;
    border-radius:30px;
    overflow:hidden;
    border:1px solid #edf2f7;
    box-shadow:
    0 12px 35px rgba(0,0,0,.06);
  }

  /* MOBILE */

  @media(max-width:960px){

    .hero{
      min-height:650px;
    }

    .hero-content{
      left:28px;
      right:28px;
    }

    .hero-title{
      font-size:52px;
    }

    .section-title{
      font-size:32px;
    }

  }

  @media(max-width:600px){

    .hero{
      min-height:580px;
      border-radius:26px;
    }

    .hero-title{
      font-size:38px;
      letter-spacing:-2px;
    }

    .hero-sub{
      font-size:15px;
    }

    .hero-content{
      top:auto;
      bottom:40px;
      transform:none;
    }

    .section-title{
      font-size:26px;
    }

    .product-image{
      height:220px;
    }

    .new-price{
      font-size:26px;
    }

    .cat-card{
      min-width:145px;
    }

    .cat-img{
      height:120px;
    }

    .mini-title{
      font-size:24px;
    }

  }


  /* MINI SLIDER COLLECTION */

  .collection-section{
    position:relative;
  }

  .section-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
  }

  .section-badge{
    display:inline-flex;
    padding:8px 14px;
    border-radius:999px;
    background:#eef4ff;
    color:#1565ff;
    font-size:12px;
    font-weight:800;
    letter-spacing:.5px;
    margin-bottom:12px;
  }

  .section-title{
    font-size:38px;
    font-weight:900;
    color:#0f172a;
    line-height:1;
  }

  .section-subtitle{
    margin-top:10px;
    color:#64748b;
    font-size:15px;
  }

  /* DESKTOP */

  .desktop-slider{
    overflow:hidden;
  }

  .desktop-banner-wrapper{
    width:320px;
    margin:0 12px;
    cursor:pointer;
    transition:.35s;
  }

  .desktop-banner-wrapper:hover{
    transform:
      translateY(-8px);
  }

  .desktop-banner{
    border-radius:24px;
    overflow:hidden;
    box-shadow:
      0 12px 35px rgba(0,0,0,.08);
  }

  /* MOBILE */

  .mobile-banner-wrapper{
    padding:4px;
  }

  .mobile-banner{
    border-radius:22px;
    overflow:hidden;
    box-shadow:
      0 12px 35px rgba(0,0,0,.08);
  }

  /* FLECHAS */

  .v-slide-group__prev,
  .v-slide-group__next{
    min-width:52px !important;
  }

  .v-slide-group__prev .v-icon,
  .v-slide-group__next .v-icon{
    font-size:34px !important;
    color:#1565ff;
  }

  /* RESPONSIVE */

  @media(max-width:960px){
    .section-header{
      display:block;
    }

    .section-title{
      font-size:30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue